import React, { memo } from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import SliderCard from "../SliderCard";
import Autocomplete from "../Autocomplete";

const useStyles = makeStyles(() => ({
  sliderWrapper: {
    width: "50%",
  },
}));

export const SliderCardAutocomplete = ({
  options = [],
  onChange,
  value,
  groupBy,
  sliderTitle,
  inputLabel,
}) => {
  const classes = useStyles();

  return (
    <SliderCard title={sliderTitle}>
      <Box className={classes.sliderWrapper}>
        <Autocomplete
          onChange={onChange}
          value={value}
          label={inputLabel}
          variant="outlined"
          options={options}
          groupBy={groupBy}
          popperProps={{ placement: "bottom-start" }}
          dataTestId={inputLabel}
        />
      </Box>
    </SliderCard>
  );
};

export default memo(SliderCardAutocomplete);
